/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9eddebd4 (Tue Feb 17 18:34:36 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface FetchShopifyMultipassUrlResponse
 */
export interface FetchShopifyMultipassUrlResponse {
  /**
   * A url that will log the user into Shopify.
   * @type string
   * @memberof FetchShopifyMultipassUrlResponse
   */
  redirectUrl: string
}

export function FetchShopifyMultipassUrlResponseFromJSON(
  json: any
): FetchShopifyMultipassUrlResponse {
  return FetchShopifyMultipassUrlResponseFromJSONTyped(json, false)
}

export function FetchShopifyMultipassUrlResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchShopifyMultipassUrlResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    redirectUrl: json['redirectUrl'],
  }
}

export function FetchShopifyMultipassUrlResponseToJSON(
  value?: FetchShopifyMultipassUrlResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    redirectUrl: value.redirectUrl,
  }
}
